/**
 * 阿里云 CDN 图片处理：按指定宽度等比缩放。
 * 文档：https://help.aliyun.com/zh/cdn/user-guide/image-processing-operation-method
 *
 * 若链接已包含阿里云图片处理参数（image_process），则原样返回，不再重复追加。
 */
export const resizeImage = (url?: string | null, width = 200): string => {
  if (!url) return url ?? ""
  if (url.includes("image_process=")) return url
  const sep = url.includes("?") ? "&" : "?"
  return `${url}${sep}image_process=resize,w_${width}`
}
